<section class="iphone15-section">
    <iframe
    [src]="iPhone15Url"
    width="100%"
    height="800"
    style="border: none;"
    ></iframe>
    </section>